<template>
  <div class="hello">
    <h1>Page NotFound</h1>
  </div>
</template>

<script>
  export default {};
</script>